import React, { useEffect, useState } from "react";
import SummaryTable from "../SummaryTable";
import { getAllMedicalStaff } from "../service-layer/MedicalStaffService";
import { useNavigate } from "react-router-dom";

// todo: implement loading while fetching data so that when unauthorized user navigate
//  here we don't see a empty table then navigate, but loading then navigate to unauthorized
//  landing page

// todo: right now when a component that is contain in a protect page is rendered, we simply
//  redirect toward the unauthorized page. properly handle the unauthorized navigation with the url
const DbTableListTest = () => {
  const [medicalStaff, setMedicalStaff] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getAllMedicalStaff().then((response) => {
      if (response?.status === 200) {
        // if the password provided is correct, the response status will be 200
        setMedicalStaff(response.data);
      } else if (response?.status === 403) {
        // 403 FORBIDDEN the authentication failed
        console.log("unauthorized");
        return navigate("/unauthorized");
      } else {
        // something else happened
        console.log(response);
        console.log("something else happened");
        // todo: manager this case in the frontend
      }
    });
  }, []);
  return (
    <div>
      <SummaryTable medicalStaff={medicalStaff} />
    </div>
  );
};

export default DbTableListTest;
